import { View } from "./ClinicSettings.view";

export const Container = () => {
  return <View />;
};
